import { UnitsDto } from "@dashboard/modules/material-management/unit/model/units.dto";
import { SpeCodeDto } from "@dashboard/modules/application-params/specode/model/specode.dto";
import { UnitSetDto } from "@dashboard/modules/material-management/unit-set/model/unit-set.dto";
import { VatGroupsDto } from "@dashboard/modules/application-params/vat-group/model/vat-groups.dto";

export class MaterialDto {
  id?: number;
  status?: string;
  code?: string;
  description?: string;
  short_description?: string;
  product_number?: string;
  product_group?: string;
  package_type?: string;
  user_count?: number;
  type?: any;
  material_companies?: any;
  vat_group?: VatGroupsDto;
  unit_set?: UnitSetDto;
  base_unit?: UnitsDto;
  material_units?: Array<any>;
  special_code?: SpeCodeDto;
  special_code2?: SpeCodeDto;
  special_code3?: SpeCodeDto;
  special_code4?: SpeCodeDto;
}
